// PrivacyPolicy.js
import React from "react";
import { Link, useLocation, BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";


export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col text-gray-900"
      style={{
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        background: "linear-gradient(to bottom, #a0d8ff, #e6f3ff)",
      }}
    >
      {/* Navbar (optional, matches your site style) */}
      <nav className="w-full flex justify-center mt-6">
        <div className="flex flex-wrap items-center justify-between gap-3 px-6 py-3 bg-white shadow-md rounded-full w-full max-w-screen-xl">
          <div
            className="font-bold text-lg md:text-xl px-4 py-2 rounded-full cursor-pointer"
            onClick={() => navigate("/")}
          >
            CollegeNavi
          </div>

          <Link
            to="/"
            className="px-4 py-2 rounded-full font-medium text-gray-900 hover:bg-gray-200 transition"
          >
            Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1 flex items-center justify-center px-6 md:px-12 mt-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white max-w-2xl w-full p-8 rounded-2xl shadow-lg border border-gray-200"
        >
          <h1 className="text-3xl font-extrabold mb-4 text-teal-800">
            Privacy Policy
          </h1>

          <p className="text-gray-700 mb-3">
            We use Google Sign-In to authenticate users.
          </p>

          <p className="text-gray-700 mb-3">
            We do not sell user data.
          </p>

          <p className="text-gray-700 mb-3">
            Basic profile information (name and email) is used only to provide
            account access.
          </p>

          <p className="text-gray-700 mt-4">
            Contact:{" "}
            <a
              href="mailto:collegecuriouspodcast@gmail.com"
              className="text-teal-700 font-medium hover:underline"
            >
              collegecuriouspodcast@gmail.com
            </a>
          </p>
        </motion.div>
      </main>
    </div>
  );
}
